import { Injectable } from "@angular/core";
import { filter, map, Observable, of, take } from "rxjs";
import { products, SourceChannel, LANGUAGE, Product } from "@prequalification/models";

@Injectable({
  providedIn: "root"
})
export class ProductService {
  private _campaignCode = "";
  private _pid = "";
  private _chnl = SourceChannel.CCPA;
  private _lang = LANGUAGE.EN;

  product$: Observable<Product | undefined>;

  constructor() {
    this.product$ = of<Product[]>(products).pipe(
      take(1),
      map((products: Product[]) => products.find((product) => product.id.toLowerCase() === this.pid.toLowerCase())),
      filter((product) => !!product)
    );
  }

  public get campaignCode() {
    return this._campaignCode;
  }

  public set campaignCode(value) {
    this._campaignCode = value;
  }

  public get pid() {
    return this._pid;
  }

  public set pid(value) {
    this._pid = value;
  }

  public get chnl() {
    return this._chnl;
  }

  public set chnl(value) {
    this._chnl = value;
  }

  public get lang() {
    return this._lang;
  }
  public set lang(value) {
    this._lang = value;
  }

  getProductName(product: Product): string {
    return this.lang === LANGUAGE.FR ? product.desc.fr.productCodeDesc : product.desc.en.productCodeDesc;
  }
}
